export default __webpack_public_path__ + "static/media/19.2d352fca.jpg";